import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
//import "./example-styles.css";
//import "./styles.css";
//import { Responsive, WidthProvider } from "react-grid-layout";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import CierreEmergencias from "./CierreEmergencias";
import CierreFuccia from "./CierreFuccia";
import ConsumoMedicamentos from "./ConsumoMedicamentos";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
//import NewWindow from "react-new-window";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import detectZoom from "detect-zoom";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import Fab from "@mui/material/Fab";
import NavigationIcon from "@mui/icons-material/Navigation";
import AddIcon from "@mui/icons-material/Add";
import ConsultaServicio from "./ConsultaServicio";
import NotasServicio from "./NotasServicio";
import ResumenServicio from "./ResumenServicio";
import ResumenMoviles from "./ResumenMoviles";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
//import classNames from "classnames";
import { classNames } from "primereact/utils";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import clsx from "clsx";
import { Tooltip } from "primereact/tooltip";
import { Badge } from "primereact/badge";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import HouseIcon from "@mui/icons-material/House";
import AdjustIcon from "@mui/icons-material/Adjust";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import FlagIcon from "@mui/icons-material/Flag";
import { Dialog } from "primereact/dialog";
import { Tag } from "primereact/tag";
import { ScrollPanel } from "primereact/scrollpanel";
import "../../../assets/css/ScrollPanelDemo.css";
import "../../../assets/css/DataTableDemo.css";
import "../../../assets/css/DialogDemo.css";
import "../../../assets/css/DropDown.css";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { SelectButton } from "primereact/selectbutton";
import { SplitButton } from "primereact/splitbutton";
import MoodBadIcon from "@mui/icons-material/MoodBad";
import { MultiSelect } from "primereact/multiselect";
import { saveAs } from "file-saver";
import { styled } from "@mui/material/styles";
import { Navigate, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import { useParams } from "react-router-dom";
import axios from "axios";
import { TextareaAutosize } from "@mui/base";
import { Dropdown } from "primereact/dropdown";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import logo1 from "../../../assets/images/mediclogo.png";
import logo2 from "../../../assets/images/cardiologo.png";
import logo3 from "../../../assets/images/logoargentina.png";
import logo4 from "../../../assets/images/masteredlogo.png";
import logo5 from "../../../assets/images/maxsalud.png";
import logo6 from "../../../assets/images/ambulanceapp.png";
import Autocomplete from "@mui/material/Autocomplete";
import { DataScroller } from "primereact/datascroller";
import { DataView } from "primereact/dataview";
import packageJson from "../../../../package.json";

export default function ServiciosTelefonos(props) {
  //const classes = useStyles();
  //const theme = useTheme();

  const sexos = [
    { nombre: "M", dataKey: "m" },
    { nombre: "F", dataKey: "f" },
    { nombre: "O", dataKey: "o" },
  ];

  const [numeroTelefono, setNumeroTelefono] = useState(null);
  const [claveTelefono, setClaveTelefono] = useState(null);
  const [telefonoId, setTelefonoId] = useState(null);
  const [telefonoIdStorage, setTelefonoIdStorage] = useState(null);
  const [resolution, setResolution] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [visibleInicializar, setVisibleInicializar] = useState(false);
  const [visibleDatos, setVisibleDatos] = useState(false);
  const [visibleReceta1, setVisibleReceta1] = useState(false);
  const [visibleReceta2, setVisibleReceta2] = useState(false);
  const [visibleIndicaciones, setVisibleIndicaciones] = useState(false);
  const [visibleDiagnostico, setVisibleDiagnostico] = useState(false);
  const [visibleGestion, setVisibleGestion] = useState(false);
  useState(false);
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState(null);
  const [bandStart, setBandStart] = useState(false);
  const [bandMovil, setBandMovil] = useState(false);
  const [confirmarApp, setConfirmarApp] = useState(false);
  const [tripulacionApp, setTripulacionApp] = useState(null);
  const [bandNuevoServicio, setBandNuevoServicio] = useState(false);
  const [first, setFirst] = useState(true);
  const toast = useRef(null);
  const alertContext = useContext(AlertContext);
  const { mensajeAlerta, mensajeAlertaTR, mensajeAlertaTL } = alertContext;
  const [selectedColors, setSelectedColors] = useState(null);
  const [selectedZona, setSelectedZona] = useState(null);
  const [selectedMovils, setSelectedMovils] = useState(null);
  const [liberado, setLiberado] = useState(false);
  const [openModalEmergencia, setOpenModalEmergencia] = useState(false);
  const [openModalFuccia, setOpenModalFuccia] = useState(false);
  const [openModalMedicamentos, setOpenModalMedicamentos] = useState(false);
  const [medicamentoElegido, setMedicamentoElegido] = useState(null);
  const [cantidadMedicamento, setCantidadMedicamento] = useState(null);
  const [presentacionElegida, setPresentacionElegida] = useState(null);
  const [medicamentosRecetas, setMedicamentosRecetas] = useState([]);
  const [numeroMovil, setNumeroMovil] = useState(null);
  const [fechaMovil, setFechaMovil] = useState(null);
  const [fechaActual, setFechaActual] = useState(null);
  const [ubicacion, setUbicacion] = useState(null);
  const [error, setError] = useState(null);
  const [lastUbicacion, setLastUbicacion] = useState(null);
  const acMotivo = useRef(null);
  const motivoEnvio = "SE ENVIA MOVIL PRESENCIAL";

  let navigate = useNavigate();

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado, iniciarSesionApp, cerrarSesion } =
    authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    configuracion,
    medicamentos,
    presentaciones,
    movil,
    diagnosticos,
    medico,
    telefono,
    recetas,
    antecedentes,
    tratamientos,
    motivosConsultas,
    obrasSocialesMedicas,
    obtenerObrasSocialesRecetario,
    obtenerMedicamentosTelemedicina,
    obtenerConfiguracion,
    obtenerMovil,
    obtenerMedicoRecetario,
    obtenerDiagnosticos,
    obtenerRecetas,
    generarIndicacionesTelemedicina,
    anularRecetas,
    enviarRecetas,
    obtenerMotivosConsultas,
    obtenerAntecedentes,
    obtenerTratamientos,
    obtenerTelefono,
    registrarTelefono,
  } = configuracionContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    servicioTelefono,
    servicioSeleccionado,
    servicioTelefonoActivos,
    notas,
    cierreEmergencias,
    cierreFuccia,
    chipData,
    trasladoServicio,
    obtenerServicioTelefono,
    obtenerNotasTelemedicina,
    guardarServicioTelefono,
    guardarServicioSeleccionado,
    cerrarServicioTelefono,
    guardarCierreMedicamentos,
    obtenerTrasladoServicio,
    confirmarRecepcion,
    salidaMovil,
    llegadaMovil,
    cerrarServicioEmergencia,
    finalizarTrasladoServicio,
  } = serviciosContext;

  let { id } = useParams();
  let { idMovil } = useParams();

  useEffect(() => {
    usuarioAutenticado();
  }, [state.id]);

  useEffect(() => {
    let version = localStorage.getItem("version");
    if (version != packageJson.version) {
      if ("caches" in window) {
        caches.keys().then((names) => {
          // Delete all the cache files
          names.forEach((name) => {
            caches.delete(name);
          });
        });

        // Makes sure the page reloads. Changes are only visible after you refresh.
        window.location.reload(true);
      }

      localStorage.clear();
      localStorage.setItem("version", packageJson.version);
    }
  }, []);

  useEffect(() => {
    if (id && state.autenticado) {
      obtenerServicioTelefono({ servicioId: id });
      obtenerNotasTelemedicina({ servicioId: id });
      obtenerTrasladoServicio({ servicioId: id });
    }
  }, [id, state]);

  useEffect(() => {
    setTelefonoIdStorage(localStorage.getItem("telefonoId"));
    //localStorage.removeItem("telefonoId");
  }, []);

  /*
  useEffect(() => {
    let movilId = localStorage.getItem("movilId");
    let movilFecha = localStorage.getItem("movilFecha");
    setNumeroMovil(movilId);
    setFechaMovil(movilFecha);
    let date = new Date();
    let newDate = new Date(date);
    newDate.setHours(date.getHours() - 3);
    setFechaActual(newDate.toISOString());
  }, []);
  */

  useEffect(() => {
    obtenerConfiguracion();
    //obtenerObrasSocialesRecetario();
    //obtenerMedicamentosTelemedicina();
    obtenerDiagnosticos();
    obtenerMotivosConsultas({ todos: false });
    obtenerAntecedentes({ todos: false });
    obtenerTratamientos({ todos: false });

    //localStorage.removeItem("motivoConsultaId");
  }, []);

  /*
  useEffect(() => {
    if (servicioTelefono && servicioTelefono.tripulaciones) {
      obtenerTelefono({
        idTelefono: servicioTelefono.tripulaciones.telefonoId,
      });
    }
  }, [servicioTelefono]);
  */

  /*
  useEffect(() => {
    if (movil) {
      obtenerMedicoRecetario({ recetarioId: movil.recetarioId });
    }
  }, [movil]);
  */

  useEffect(() => {
    setVisibleDatos(false);
    setVisibleReceta1(false);
    setVisibleReceta2(false);
    setVisibleIndicaciones(false);
    setVisibleDiagnostico(false);
    setVisibleGestion(false);
  }, []);

  const exitClick = (e) => {
    navigate(`/`);
  };

  useEffect(() => {
    if (configuracion && configuracion.location) {
      // Función para obtener la ubicación
      const obtenerUbicacion = () => {
        if (!navigator.geolocation) {
          setError("La geolocalización no es compatible con tu navegador.");
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (posicion) => {
            setUbicacion({
              latitud: posicion.coords.latitude,
              longitud: posicion.coords.longitude,
            });
            setError(null);
          },
          (err) => {
            setError(err.message);
          },
          {
            // Opciones de configuración de la geolocalización
            enableHighAccuracy: true, // Mayor precisión
            timeout: 5000, // Tiempo de espera máximo en milisegundos
            maximumAge: 0, // No utilizar una ubicación en caché
          }
        );
      };

      // Obtiene la ubicación la primera vez que el componente se monta
      obtenerUbicacion();

      // Configura el intervalo para obtener la ubicación cada 1 minuto
      const intervaloId = setInterval(obtenerUbicacion, 60000); // 60000 ms = 1 minuto

      // Función de limpieza que se ejecuta cuando el componente se desmonta
      return () => clearInterval(intervaloId);
    }
  }, [configuracion]); // El array de dependencias vacío asegura que el efecto se ejecute solo una vez al montar

  const llamadoCelular = async () => {
    return (
      <a href={"tel:+549" + servicioTelefono.celular}>
        {servicioTelefono.celular}
      </a>
    );
  };

  const confirmaRecepcion = () => {
    confirmDialog({
      message: "Confirma recepción de servicio ?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFuncRecepcion(),
    });
  };

  const acceptFuncRecepcion = async () => {
    if (servicioTelefono && servicioTelefono.tripulaciones) {
      confirmarRecepcion({
        servicioId: servicioTelefono.id,
        movilId: servicioTelefono.tripulaciones.movilId,
      });

      setTimeout(() => {
        obtenerServicioTelefono({ servicioId: id });
      }, 2000);
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Móviles",
        detail: "El servicio no se puede confirmar.",
        life: 5000,
      });
    }
  };

  const confirmarSalida = () => {
    confirmDialog({
      message: "Confirma salida de móvil ?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFuncSalida(),
    });
  };

  const acceptFuncSalida = async () => {
    if (servicioTelefonoActivos.length > 0) {
      toast.current.show({
        severity: "warn",
        summary: "Móviles",
        detail: `Para iniciar un nuevo servicio debe finalizar el servicio ${servicioTelefonoActivos[0].id} del paciente ${servicioTelefonoActivos[0].nombre}.`,
        life: 5000,
      });
      return;
    }

    salidaMovil({
      tripulacionId: servicioTelefono.tripulacionId,
      servicioId: servicioTelefono.id,
      pasado: servicioTelefono.fpasado,
      usuario: servicioTelefono.tripulaciones.movilId,
      color: servicioTelefono.color,
      movilId: servicioTelefono.tripulaciones.movilId,
    });

    setTimeout(() => {
      obtenerServicioTelefono({ servicioId: id });
    }, 2000);
  };

  const confirmarLlegada = () => {
    confirmDialog({
      message: "Confirma llegada de móvil ?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFuncLlegada(),
    });
  };

  const acceptFuncLlegada = async () => {
    if (servicioTelefonoActivos.length > 0) {
      toast.current.show({
        severity: "warn",
        summary: "Móviles",
        detail: `Para iniciar un nuevo servicio debe finalizar el servicio ${servicioTelefonoActivos[0].id} del paciente ${servicioTelefonoActivos[0].nombre}.`,
        life: 5000,
      });
      return;
    }

    llegadaMovil({
      tripulacionId: servicioTelefono.tripulacionId,
      servicioId: servicioTelefono.id,
      tomado: servicioTelefono.ftomado,
      usuario: servicioTelefono.tripulaciones.movilId,
      valorServicio: 0,
      color: servicioTelefono.color,
    });

    setTimeout(() => {
      obtenerServicioTelefono({ servicioId: id });
    }, 2000);
  };

  const confirmarLlegadaTraslado = () => {
    confirmDialog({
      message: "Confirma llegada traslado ?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFuncLlegadaTraslado(),
    });
  };

  const acceptFuncLlegadaTraslado = async () => {
    if (servicioTelefonoActivos.length > 0) {
      toast.current.show({
        severity: "warn",
        summary: "Móviles",
        detail: `Para iniciar un nuevo servicio debe finalizar el servicio ${servicioTelefonoActivos[0].id} del paciente ${servicioTelefonoActivos[0].nombre}.`,
        life: 5000,
      });
      return;
    }

    finalizarTrasladoServicio({
      servicioId: servicioTelefono.id,
      trasladoServicioId: trasladoServicio.id,
      destino: trasladoServicio.destino,
      usuario: servicioTelefono.tripulaciones.movilId,
      color: servicioTelefono.color,
    });

    setTimeout(() => {
      obtenerServicioTelefono({ servicioId: id });
    }, 2000);
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  const itemTemplate = (rowData, options) => {
    const icon = "pi pi-trash";
    return (
      <Button
        type="button"
        icon={icon}
        severity={"danger"}
        className="p-button-sm p-button-text"
        onClick={() => eliminarMedicamento(rowData, options.rowIndex)}
      />
    );
  };

  const prolongadoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">T. Prolongado</span>
        <Checkbox checked={rowData.tratamientoProlongado}></Checkbox>
      </Fragment>
    );
  };

  const duplicadoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Duplicado</span>
        <Checkbox checked={rowData.duplicado}></Checkbox>
      </Fragment>
    );
  };

  const respetarTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Respetar Marca</span>
        <Checkbox checked={rowData.respetarMarca}></Checkbox>
      </Fragment>
    );
  };

  const agregarMedicamento = () => {
    const copyArray = [...medicamentosRecetas];

    copyArray.push({
      medicamento:
        medicamentoElegido.marcaComercial +
        " - " +
        medicamentoElegido.principioActivo,
      presentacion: presentacionElegida.presentacion,
      cantidad: cantidadMedicamento,
      code: presentacionElegida.code,
      tratamientoProlongado: servicioTelefono.tratamientoProlongado,
      duplicado: servicioTelefono.duplicado,
      respetarMarca: servicioTelefono.respetarMarca,
    });

    setMedicamentosRecetas(copyArray);
    //setVisible(false);
    let elem = document.getElementById("cancelarMedicamento");
    if (elem) {
      setTimeout(() => {
        elem.click();
      }, 100);
    }
  };

  const eliminarMedicamento = (data, index) => {
    medicamentosRecetas.splice(index, 1);
    let elem = document.getElementById("cancelarMedicamento");
    if (elem) {
      elem.click();
    }
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return year + "-" + month + "-" + day;
  }

  const aceptarClick = async (e) => {
    let medicines = [];

    for (var i = 0; i < medicamentosRecetas.length; i++) {
      medicines.push({
        externalId: medicamentosRecetas[i].code,
        quantity: Number(medicamentosRecetas[i].cantidad),
        genericOnly: !medicamentosRecetas[i].respetarMarca,
        longTerm: medicamentosRecetas[i].tratamientoProlongado,
        requiresDuplicate: medicamentosRecetas[i].duplicado,
      });
    }

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      `Bearer ${process.env.REACT_APP_RECETARIO_TOKEN}`
    );

    var raw = JSON.stringify({
      userId: Number(movil.recetarioId),
      date: servicioTelefono.fpasado.substring(0, 10),
      patient: {
        healthInsurance: servicioTelefono.obraSocial.trim(),
        insuranceNumber: servicioTelefono.nroObraSocial
          ? servicioTelefono.nroObraSocial.trim()
          : "",
        name: servicioTelefono.nombres.trim(),
        surname: servicioTelefono.apellido.trim(),
        documentNumber: servicioTelefono.numeroDocumento.trim(),
        //email: "prueba@recetario.com.ar",
        phone: servicioTelefono.celular ? servicioTelefono.celular : "",
        gender: servicioTelefono.sexo.toLowerCase(),
        birthDate: servicioTelefono.nacimiento,
      },
      method: "vademecum",
      diagnosis: servicioTelefono.detalleDiagnostico,
      medicines,
    });

    //console.log(raw)

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    /*    
      fetch("https://external-api.recetario.com.ar/prescriptions", requestOptions)
     .then(response => response.text())
     .then(result => console.log(result))
     .catch(error => console.log('error', error));
      */

    try {
      let response = await fetch(
        "https://external-api.recetario.com.ar/prescriptions",
        requestOptions
      );

      if (response.ok) {
        toast.current.show({
          severity: "success",
          summary: "Recetas",
          detail: "La receta se ha generado correctamente.",
          life: 3000,
        });

        const json = await response.json();

        let url = json.url;
        let id = json.id;
        //window.open(url, "_blank");

        //let idMedico = medicos.find(
        //  (element) => element.recetarioId === Number(medicoId)
        //).id;

        let datos = {
          movilId: movil.id,
          servicioId: servicioTelefono.id,
          telefono: servicioTelefono.celular,
          //email: pacienteSeleccionado.email,
          //enviarWhatsApp: pacienteSeleccionado.enviarWhatsApp,
          //enviarCorreo: pacienteSeleccionado.enviarCorreo,
          url,
          id,
        };

        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        await axios
          .post(
            process.env.REACT_APP_BACKEND_URL +
              "/api/configuracion/agregarreceta",
            datos,
            config
          )
          .then(function (response) {
            console.log(response);
          });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Recetas",
          detail: "Hubo un error al generar la receta.",
          life: 3000,
        });
      }
    } catch (error) {
      console.error(error.message);
    }

    /*
    setTimeout(() => {
      onHide();
    }, 5000);
    */
  };

  const onHide = (e) => {
    window.location.reload("/telemedicina/0");
  };

  const verificarReposo = (data) => {
    let index = data.toLowerCase().search("reposo");
    if (index !== -1) {
      toast.current.show({
        severity: "warn",
        summary: "Receta",
        detail: "Por favor cambiar la palabra reposo.",
        life: 3000,
      });
      return;
    }
  };

  const confirmarAnular = (rowData) => {
    confirmDialog({
      message:
        rowData.tipo === "RECETA"
          ? "Esta seguro de anular la receta ?"
          : "Esta seguro de anular las indicaciones ?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFuncAnular(rowData),
    });
  };

  const acceptFuncAnular = (data) => {
    anularRecetas({ id: data.id, recetaId: data.recetaId });
    setTimeout(() => {
      obtenerRecetas({ servicioId: servicioTelefono.id });
    }, 1000);
  };

  const confirmarEnviar = () => {
    confirmDialog({
      message: "Confirma envío de recetas e indicaciones",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFuncEnviar(),
    });
  };

  const acceptFuncEnviar = () => {
    if (
      servicioTelefono &&
      (!servicioTelefono.celular || servicioTelefono.celular === "")
    ) {
      toast.current.show({
        severity: "warn",
        summary: "Receta",
        detail: "Debe cargar un celular.",
        life: 3000,
      });
      return;
    }

    enviarRecetas({
      servicioId: servicioTelefono.id,
      celular: servicioTelefono.celular,
    });
  };

  const confirmarCerrar = () => {
    let motivo = diagnosticos.find(
      (item) => item.id === servicioTelefono.diagnosticoId
    ).nombre;

    confirmDialog({
      message:
        motivo !== motivoEnvio
          ? `Confirma cierre del servicio ?`
          : `Se va a generar un nuevo indicativo de color ${servicioTelefono.color}. Confirma cierre del servicio ?`,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFuncCerrar(),
    });
  };

  const acceptFuncCerrar = () => {
    cerrarServicioTelefono({
      servicioTelefono,
      destinatario: configuracion.destinatario,
    });
    setTimeout(() => {
      onHide();
    }, 2000);
  };

  const itemTemplateGestion = (data) => {
    return (
      <div className="col-12">
        <div className="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
          <div className="flex flex-column lg:flex-row justify-content-between align-items-center xl:align-items-start lg:flex-1 gap-4">
            <div className="flex flex-column align-items-center lg:align-items-start gap-3">
              <div
                className="flex flex-column gap-1"
                style={{ fontWeight: "bold", marginLeft: "1vw" }}
              >
                <div className="text-2xl font-bold text-900">{data.fecha}</div>
                <div className="text-700">{data.tipo}</div>
                <Grid container spacing={0} style={{ padding: "0" }}>
                  <Grid item xs={6} md={6}>
                    <Button
                      icon="pi pi-search"
                      label="Ver"
                      severity="success"
                      style={{ marginTop: "2vw", marginBottom: "2vw" }}
                      onClick={() => {
                        data.tipo === "RECETA"
                          ? window.open(data.url, "_blank")
                          : window.open(data.url2, "_blank");
                      }}
                    ></Button>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Button
                      icon="pi pi-trash"
                      label="Anular"
                      severity="danger"
                      style={{ marginTop: "2vw", marginLeft: "2vw" }}
                      onClick={() => {
                        confirmarAnular(data);
                      }}
                    ></Button>
                  </Grid>
                </Grid>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleClick = () => {
    if (servicioTelefonoActivos.length > 0) {
      toast.current.show({
        severity: "warn",
        summary: "Móviles",
        detail: `Para iniciar un nuevo servicio debe finalizar el servicio ${servicioTelefonoActivos[0].id} del paciente ${servicioTelefonoActivos[0].nombre}.`,
        life: 5000,
      });
      return;
    }

    if (
      !cierreEmergencias ||
      cierreEmergencias.diagnosticoId === undefined ||
      cierreEmergencias.diagnosticoId === null ||
      cierreEmergencias.diagnosticoId <= 0
    ) {
      mensajeAlerta(
        "Cierre de Servicio",
        "El diagnóstico es necesario !.",
        "error"
      );
      return;
    }

    if (
      (configuracion.destinatario !== 4 &&
        configuracion.destinatario !== 5 &&
        configuracion.destinatario !== 6) ||
      ((configuracion.destinatario === 4 ||
        configuracion.destinatario === 5 ||
        configuracion.destinatario === 6) &&
        servicioSeleccionado.color !== "AZUL")
    ) {
      if (
        !cierreEmergencias ||
        cierreEmergencias.coseguroAbonado === undefined ||
        cierreEmergencias.coseguroAbonado === null ||
        cierreEmergencias.coseguroAbonado < 0
      ) {
        mensajeAlerta(
          "Cierre de Servicio",
          "El coseguro abonado es necesario !.",
          "error"
        );
        return;
      }
    }

    if (
      configuracion &&
      configuracion.pami === servicioSeleccionado.titularId
    ) {
      mensajeAlerta(
        "Cierre de Servicio",
        "El cierre de PAMI se realiza desde central !.",
        "error"
      );
      return;
    }

    if (servicioSeleccionado.color === "FUCCIA") {
      setOpenModalFuccia(true);
      return;
    }

    if (
      configuracion &&
      configuracion.medicamentos &&
      servicioSeleccionado.movilId < 1000
    ) {
      handleMedicamentos();
      return;
    }
    handleServicio();
  };

  const handleOpenEmergencias = () => {
    setOpenModalEmergencia(true);
  };

  const handleCloseEmergencias = () => {
    setOpenModalEmergencia(false);
  };

  const handleCloseMedicamentos = () => {
    setOpenModalMedicamentos(false);
  };

  const handleCloseFuccia = () => {
    setOpenModalFuccia(false);
  };

  const handleMedicamentos = () => {
    if (servicioSeleccionado.color === "FUCCIA") {
      if (
        cierreFuccia &&
        cierreFuccia.trabaja &&
        cierreFuccia.fechaTrabaja === ""
      ) {
        mensajeAlerta("Despachos", "Debe ingresar fecha Trabaja !.", "error");
        return;
      }
      if (
        cierreFuccia &&
        cierreFuccia.citado &&
        cierreFuccia.fechaCitado === ""
      ) {
        mensajeAlerta("Despachos", "Debe ingresar fecha Citado !.", "error");
        return;
      }
    }

    if (
      configuracion &&
      configuracion.medicamentos &&
      servicioSeleccionado.movilId < 1000
    ) {
      if (
        servicioSeleccionado.almacenId === undefined ||
        servicioSeleccionado.almacenId === null
      ) {
        toast.current.show({
          severity: "info",
          summary:
            "El móvil " +
            servicioSeleccionado.movilId +
            " no tiene asignado un almacén",
        });
      }

      guardarCierreMedicamentos({
        cantidad: 1,
      });
      setOpenModalMedicamentos(true);
    } else {
      handleServicio();
    }
  };

  const handleServicio = async () => {
    handleCloseMedicamentos();
    handleCloseEmergencias();
    handleCloseFuccia();

    cerrarServicioEmergencia({
      cierreEmergencias,
      cierreFuccia,
      chipData,
      usuario: servicioTelefono.tripulaciones.movilId,
      id: servicioTelefono.id,
      movilId: servicioTelefono.tripulaciones.movilId,
      tripulacionId: servicioTelefono.tripulacionId,
      cierreHistoriaClinica: null,
      signature1: null,
      signature2: null,
      signature3: null,
      hc: false,
      final: true,
      app: false,
      almacenId: servicioTelefono.tripulaciones.almacenId,
      destinatario: configuracion.destinatario,
    });

    setTimeout(() => {
      cerrarSesion();
      window.location.reload();
    }, 2000);
  };

  const renderHeaderEmergencias = () => {
    return (
      <div>
        <Tag value="Cierre del Servicio"></Tag>
      </div>
    );
  };

  const renderFooterEmergencias = () => {
    return (
      <div>
        <Button
          label={
            servicioTelefono.color === "FUCCIA" ||
            (configuracion && configuracion.medicamentos)
              ? "Avanzar"
              : "Confirmar"
          }
          icon="pi pi-check"
          onClick={() => handleClick()}
          className="p-button-text"
          autoFocus
        />
        <Button
          label="Cerrar"
          icon="pi pi-times"
          onClick={() => handleCloseEmergencias()}
          className="p-button-text"
        />
      </div>
    );
  };

  const renderHeaderFuccia = () => {
    return (
      <div>
        <Tag value="Cierre Servicio Laboral"></Tag>
      </div>
    );
  };

  const renderFooterFuccia = () => {
    return (
      <div>
        <Button
          label={
            configuracion &&
            configuracion.medicamentos &&
            servicioSeleccionado.movilId < 1000
              ? "Avanzar"
              : "Confirmar"
          }
          icon="pi pi-check"
          onClick={() => handleMedicamentos()}
          className="p-button-text"
          autoFocus
        />
        <Button
          label="Cerrar"
          icon="pi pi-times"
          onClick={() => handleCloseFuccia()}
          className="p-button-text"
        />
      </div>
    );
  };

  const renderHeaderMedicamentos = () => {
    return (
      <div>
        <Tag value="Consumo de Medicamentos"></Tag>
      </div>
    );
  };

  const renderFooterMedicamentos = () => {
    return (
      <div>
        <Button
          label="Confirmar"
          icon="pi pi-check"
          onClick={() => handleServicio()}
          className="p-button-text"
          autoFocus
        />
        <Button
          label="Volver"
          icon="pi pi-times"
          onClick={() => handleCloseMedicamentos()}
          className="p-button-text"
        />
      </div>
    );
  };

  const confirm1 = () => {
    confirmDialog({
      message:
        "Confirma este teléfono en el móvil " +
        servicioTelefono.tripulaciones.movilId +
        " ?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept,
      reject,
    });
  };

  const accept = () => {
    toast.current.show({
      severity: "info",
      summary: "Confirmado",
      detail: "Ha confirmado el móvil",
      life: 3000,
    });

    let date = new Date();
    let newDate = new Date(date);
    newDate.setHours(date.getHours() - 3);
    window.location.reload();
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Rechazado",
      detail: "Ha rechazado la confirmación",
      life: 3000,
    });
    window.location.reload();
  };

  const verificarEstado = async () => {
    await obtenerServicioTelefono({ servicioId: id });
    return servicioTelefono.estado;
  };

  const verificarEstadoTraslados = async () => {
    handleCloseEmergencias();
    await obtenerServicioTelefono({ servicioId: id });
    await obtenerTrasladoServicio({ servicioId: id });
    return servicioTelefono.estado;
  };

  //INICIO

  if (
    !bandStart &&
    configuracion &&
    telefonoIdStorage &&
    (state.autenticado === null || state.autenticado === false)
  ) {
    setBandStart(true);
    iniciarSesionApp({ configuracion });
  }

  if (!servicioSeleccionado && servicioTelefono) {
    guardarServicioSeleccionado(servicioTelefono);
  }

  if (ubicacion && ubicacion !== lastUbicacion && telefonoIdStorage) {
    setLastUbicacion(ubicacion);

    try {
      const url =
        configuracion && configuracion.destinatario === 1
          ? `https://api.medic.com.ar/api/gps/agregarposiciongps`
          : configuracion && configuracion.destinatario === 2
          ? `https://api.cardio24hs.ar/api/gps/agregarposiciongps`
          : configuracion && configuracion.destinatario === 3
          ? `http://186.19.65.170:4000/api/gps/agregarposiciongps`
          : configuracion && configuracion.destinatario === 4
          ? `https://api.mastered.ar/api/gps/agregarposiciongps`
          : configuracion && configuracion.destinatario === 5
          ? `https://api.maxsalud.ar/api/gps/agregarposiciongps`
          : configuracion && configuracion.destinatario === 6
          ? `https://api.mitoemergencias.com.ar/api/gps/agregarposiciongps`
          : null;
      //const url = `https://api.medic.com.ar/api/gps/agregarposiciongps`;
      axios.post(url, {
        lat: ubicacion.latitud,
        lon: ubicacion.longitud,
        telefono: telefonoIdStorage,
      }); // you should use post instead of get to persist data on the backend
      //console.log(global)
    } catch (err) {
      console.error(err);
    }
  }

  // FIN

  //console.log(servicioTelefono);
  //console.log(error);
  //console.log(trasladoServicio);

  return (
    <Fragment>
      <Toast ref={toast} />
      <ConfirmDialog />
      <Fragment>
        <Grid container spacing={0} style={{ padding: "0" }}>
          <Grid item xs={4} md={4}>
            {configuracion && configuracion.destinatario === 1 ? (
              <img
                src={logo1}
                alt="Logo"
                height="50"
                style={{ marginLeft: "2em", marginTop: "0.2em" }}
              />
            ) : null}
            {configuracion && configuracion.destinatario === 2 ? (
              <img
                src={logo2}
                alt="Logo"
                height="50"
                style={{ marginLeft: "2em", marginTop: "0.2em" }}
              />
            ) : null}
            {configuracion && configuracion.destinatario === 3 ? (
              <img
                src={logo3}
                alt="Logo"
                height="50"
                style={{ marginLeft: "2em", marginTop: "0.2em" }}
              />
            ) : null}
            {configuracion && configuracion.destinatario === 4 ? (
              <img
                src={logo4}
                alt="Logo"
                height="50"
                style={{ marginLeft: "2em", marginTop: "0.2em" }}
              />
            ) : null}
            {configuracion && configuracion.destinatario === 5 ? (
              <img
                src={logo5}
                alt="Logo"
                height="50"
                style={{ marginLeft: "2em", marginTop: "0.2em" }}
              />
            ) : null}
            {configuracion && configuracion.destinatario === 6 ? (
              <img
                src={logo6}
                alt="Logo"
                height="50"
                style={{ marginLeft: "2em", marginTop: "0.2em" }}
              />
            ) : null}
          </Grid>
          {state.autenticado &&
          servicioTelefono &&
          servicioTelefono.tripulaciones &&
          telefonoIdStorage &&
          Number(telefonoIdStorage) ===
            servicioTelefono.tripulaciones.telefonoId ? (
            <Grid item xs={8} md={8}>
              <h2 style={{ textAlign: "center" }}>
                {`Móvil ${servicioTelefono.tripulaciones.movilId} (${id}) (${servicioTelefono.color})`}
              </h2>
            </Grid>
          ) : null}
        </Grid>

        {/*INICIANDO  PANTALLAS*/}

        {/*  
        {!servicioTelefono && id !== 0 ? (
          <h2 style={{ textAlign: "center" }}>Servicio Inexistente</h2>
        ) : null}

        {!servicioTelefono && id === 0 ? (
          <h2 style={{ textAlign: "center" }}>Servicio Cerrado</h2>
        ) : null}
        */}

        {state.autenticado &&
        servicioTelefono &&
        servicioTelefono.tripulaciones &&
        telefonoIdStorage &&
        Number(telefonoIdStorage) ===
          servicioTelefono.tripulaciones.telefonoId ? (
          <Fragment>
            {servicioTelefono &&
            servicioTelefono.estado === "PASADO" &&
            !servicioTelefono.recepcionApp &&
            !visibleDatos &&
            !visibleReceta1 &&
            !visibleReceta2 &&
            !visibleIndicaciones &&
            !visibleDiagnostico &&
            !visibleGestion ? (
              <Grid container spacing={0} style={{ padding: "0" }}>
                <Grid item xs={6} md={6}>
                  <Button
                    type="button"
                    label="Confirmar Recepción"
                    icon="pi pi-check"
                    style={{
                      marginLeft: "2vw",
                    }}
                    className="p-button-success"
                    onClick={() => {
                      verificarEstado()
                        .then((result) => {
                          if (result === "PASADO") {
                            confirmaRecepcion();
                          } else {
                            window.location.reload();
                          }
                        })
                        .catch((error) => {
                          console.error("Error fetching data:", error);
                        });
                    }}
                  />
                </Grid>
              </Grid>
            ) : null}

            {servicioTelefono &&
            servicioTelefono.estado === "PASADO" &&
            servicioTelefono.recepcionApp &&
            !visibleDatos &&
            !visibleReceta1 &&
            !visibleReceta2 &&
            !visibleIndicaciones &&
            !visibleDiagnostico &&
            !visibleGestion ? (
              <Grid container spacing={0} style={{ padding: "0" }}>
                <Grid item xs={6} md={6}>
                  <Button
                    type="button"
                    label="Confirmar Salida Móvil"
                    icon="pi pi-check"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                    }}
                    className="p-button-success"
                    onClick={() => {
                      verificarEstado()
                        .then((result) => {
                          if (result === "PASADO") {
                            confirmarSalida();
                          } else {
                            window.location.reload();
                          }
                        })
                        .catch((error) => {
                          console.error("Error fetching data:", error);
                        });
                    }}
                  />
                </Grid>

                <Grid item xs={6} md={6}>
                  <Button
                    label="Datos del Paciente"
                    icon="pi pi-search"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                    }}
                    disabled={!servicioTelefono}
                    className="p-button-info"
                    onClick={() => {
                      setVisibleDatos(true);
                      setVisibleReceta1(false);
                      setVisibleReceta2(false);
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <a href={"tel:+549" + servicioTelefono.celular}>
                    <Button
                      label="Llamado al Celular"
                      icon="pi pi-phone"
                      style={{
                        marginLeft: "2vw",
                        marginRight: "2vw",
                        marginTop: "2vw",
                      }}
                      disabled={!servicioTelefono}
                      className="p-button-info"
                    />
                  </a>
                </Grid>

                <Grid item xs={6} md={6}>
                  <Button
                    label="Abrir Google Maps"
                    icon="pi pi-map-marker"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                      marginTop: "2vw",
                    }}
                    disabled={!servicioTelefono}
                    className="p-button-info"
                    onClick={() => {
                      const encodedDireccion = encodeURIComponent(
                        servicioTelefono.domicilio
                      );
                      // Construye la URL de Google Maps
                      const urlMaps = `https://www.google.com/maps/search/?api=1&query=${encodedDireccion}`;
                      window.open(urlMaps, "_blank");
                    }}
                  />
                </Grid>
              </Grid>
            ) : null}

            {servicioTelefono &&
            servicioTelefono.estado === "SALIDA" &&
            !visibleDatos &&
            !visibleReceta1 &&
            !visibleReceta2 &&
            !visibleIndicaciones &&
            !visibleDiagnostico &&
            !visibleGestion ? (
              <Grid container spacing={0} style={{ padding: "0" }}>
                <Grid item xs={6} md={6}>
                  <Button
                    type="button"
                    label="Confirmar Llegada"
                    icon="pi pi-check"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                    }}
                    className="p-button-success"
                    onClick={() => {
                      verificarEstado()
                        .then((result) => {
                          if (result === "SALIDA") {
                            confirmarLlegada();
                          } else {
                            window.location.reload();
                          }
                        })
                        .catch((error) => {
                          console.error("Error fetching data:", error);
                        });
                    }}
                  />
                </Grid>

                <Grid item xs={6} md={6}>
                  <Button
                    label="Datos del Paciente"
                    icon="pi pi-search"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                    }}
                    disabled={!servicioTelefono}
                    className="p-button-info"
                    onClick={() => {
                      setVisibleDatos(true);
                      setVisibleReceta1(false);
                      setVisibleReceta2(false);
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <a href={"tel:+549" + servicioTelefono.celular}>
                    <Button
                      label="Llamado al Celular"
                      icon="pi pi-phone"
                      style={{
                        marginLeft: "2vw",
                        marginRight: "2vw",
                        marginTop: "2vw",
                      }}
                      disabled={!servicioTelefono}
                      className="p-button-info"
                    />
                  </a>
                </Grid>

                <Grid item xs={6} md={6}>
                  <Button
                    label="Abrir Google Maps"
                    icon="pi pi-map-marker"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                      marginTop: "2vw",
                    }}
                    disabled={!servicioTelefono}
                    className="p-button-info"
                    onClick={() => {
                      const encodedDireccion = encodeURIComponent(
                        servicioTelefono.domicilio
                      );
                      // Construye la URL de Google Maps
                      const urlMaps = `https://www.google.com/maps/search/?api=1&query=${encodedDireccion}`;
                      window.open(urlMaps, "_blank");
                    }}
                  />
                </Grid>
              </Grid>
            ) : null}

            {servicioTelefono &&
            servicioTelefono.estado === "LLEGADA" &&
            !visibleDatos &&
            !visibleReceta1 &&
            !visibleReceta2 &&
            !visibleIndicaciones &&
            !visibleDiagnostico &&
            !visibleGestion ? (
              <Grid container spacing={0} style={{ padding: "0" }}>
                <Grid item xs={6} md={6}>
                  <Button
                    label="Cierre del Servicio"
                    icon="pi pi-check"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                    }}
                    disabled={!servicioTelefono}
                    className="p-button-success"
                    onClick={() => {
                      //servicioTelefono.nacimiento = formatDate(servicioTelefono.nacimiento)

                      verificarEstado()
                        .then((result) => {
                          console.log(result);
                          if (result === "LLEGADA") {
                            handleOpenEmergencias();
                          } else {
                            handleCloseEmergencias();
                            window.location.reload();
                          }
                        })
                        .catch((error) => {
                          console.error("Error fetching data:", error);
                        });
                    }}
                  />
                </Grid>

                <Grid item xs={6} md={6}>
                  <Button
                    label="Datos del Paciente"
                    icon="pi pi-search"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                    }}
                    disabled={!servicioTelefono}
                    className="p-button-info"
                    onClick={() => {
                      setVisibleDatos(true);
                      setVisibleReceta1(false);
                      setVisibleReceta2(false);
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <a href={"tel:+549" + servicioTelefono.celular}>
                    <Button
                      label="Llamado al Celular"
                      icon="pi pi-phone"
                      style={{
                        marginLeft: "2vw",
                        marginRight: "2vw",
                        marginTop: "2vw",
                      }}
                      disabled={!servicioTelefono}
                      className="p-button-info"
                    />
                  </a>
                </Grid>
                {/*
                <Grid item xs={6} md={6}>
                  <Button
                    label="Carga de Diagnóstico"
                    icon="pi pi-pencil"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                      marginTop: "2vw",
                    }}
                    disabled={!servicioTelefono}
                    className="p-button-info"
                    onClick={() => {
                      guardarServicioTelefono({
                        ...servicioTelefono,
                        diagnosticoId: Number(
                          localStorage.getItem("diagnosticoId")
                        ),
                        detalleDiagnostico:
                          localStorage.getItem("detalleDiagnostico"),
                        motivoConsultaId: Number(
                          localStorage.getItem("motivoConsultaId")
                        ),
                      });
                      setVisibleDiagnostico(true);
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <Button
                    label="Generación de Recetas"
                    icon="pi pi-align-left"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                      marginTop: "2vw",
                    }}
                    disabled={!servicioTelefono}
                    className="p-button-info"
                    onClick={() => {
                      if (
                        servicioTelefono &&
                        (!servicioTelefono.diagnosticoId ||
                          !servicioTelefono.detalleDiagnostico)
                      ) {
                        toast.current.show({
                          severity: "warn",
                          summary: "Receta",
                          detail: "Primero debe cargar el diagnóstico.",
                          life: 3000,
                        });
                        return;
                      }

                      if (
                        !servicioTelefono.apellido &&
                        !servicioTelefono.nombres
                      ) {
                        let espacio = servicioTelefono.nombre.search(" ");
                        let caracteres = servicioTelefono.nombre.length;
                        const nombre = servicioTelefono.nombre;
                        servicioTelefono.apellido = nombre.substring(
                          0,
                          espacio
                        );
                        servicioTelefono.nombres = nombre.substring(
                          espacio + 1,
                          caracteres
                        );
                      }
                      //servicioTelefono.nacimiento = formatDate(servicioTelefono.nacimiento)
                      setVisibleReceta1(true);
                    }}
                  />
                </Grid>

                <Grid item xs={6} md={6}>
                  <Button
                    label="Gestión de Documentos"
                    icon="pi pi-file-pdf"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                      marginTop: "2vw",
                    }}
                    disabled={!servicioTelefono}
                    className="p-button-info"
                    onClick={() => {
                      //servicioTelefono.nacimiento = formatDate(servicioTelefono.nacimiento)
                      setVisibleDatos(false);
                      setVisibleReceta1(false);
                      setVisibleReceta2(false);
                      obtenerRecetas({ servicioId: id });
                      setTimeout(() => {
                        setVisibleGestion(true);
                      }, 1000);
                    }}
                  />
                </Grid>


                <Grid item xs={3} md={3} />
                <Grid item xs={3} md={3} />
                */}

                <Dialog
                  header={renderHeaderEmergencias()}
                  visible={openModalEmergencia}
                  closable={false}
                  footer={renderFooterEmergencias()}
                  breakpoints={{ "960px": "95vw" }}
                  style={{ width: "95vw", paddingBottom: "0" }}
                  position="left"
                >
                  <CierreEmergencias />

                  <br />
                </Dialog>

                <Dialog
                  header={renderHeaderFuccia()}
                  visible={openModalFuccia}
                  closable={false}
                  footer={renderFooterFuccia()}
                  breakpoints={{ "960px": "95vw" }}
                  style={{ width: "95vw", paddingBottom: "0" }}
                  position="left"
                >
                  <CierreFuccia />

                  <br />
                </Dialog>

                <Dialog
                  header={renderHeaderMedicamentos()}
                  visible={openModalMedicamentos}
                  closable={false}
                  footer={renderFooterMedicamentos()}
                  breakpoints={{ "960px": "75vw" }}
                  style={{ width: "50vw", paddingBottom: "0" }}
                  position="right"
                >
                  <ConsumoMedicamentos />

                  <br />
                </Dialog>
              </Grid>
            ) : null}

            {servicioTelefono &&
            servicioTelefono.estado === "TRASLADO" &&
            !visibleDatos &&
            !visibleReceta1 &&
            !visibleReceta2 &&
            !visibleIndicaciones &&
            !visibleDiagnostico &&
            !visibleGestion ? (
              <Grid container spacing={0} style={{ padding: "0" }}>
                <Grid item xs={6} md={6}>
                  <Button
                    type="button"
                    label="Llegada Traslado"
                    icon="pi pi-check"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                    }}
                    className="p-button-success"
                    onClick={() => {
                      verificarEstadoTraslados()
                        .then((result) => {
                          if (result === "TRASLADO") {
                            confirmarLlegadaTraslado();
                          } else {
                            window.location.reload();
                          }
                        })
                        .catch((error) => {
                          console.error("Error fetching data:", error);
                        });
                    }}
                  />
                </Grid>

                <Grid item xs={6} md={6}>
                  <Button
                    label="Datos del Paciente"
                    icon="pi pi-search"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                    }}
                    disabled={!servicioTelefono}
                    className="p-button-info"
                    onClick={() => {
                      setVisibleDatos(true);
                      setVisibleReceta1(false);
                      setVisibleReceta2(false);
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <a href={"tel:+549" + servicioTelefono.celular}>
                    <Button
                      label="Llamado al Celular"
                      icon="pi pi-phone"
                      style={{
                        marginLeft: "2vw",
                        marginRight: "2vw",
                        marginTop: "2vw",
                      }}
                      disabled={!servicioTelefono}
                      className="p-button-info"
                    />
                  </a>
                </Grid>

                <Grid item xs={6} md={6}>
                  <Button
                    label="Abrir Google Maps"
                    icon="pi pi-map-marker"
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                      marginTop: "2vw",
                    }}
                    disabled={!trasladoServicio}
                    className="p-button-info"
                    onClick={() => {
                      const encodedDireccion = encodeURIComponent(
                        trasladoServicio.destino
                      );
                      // Construye la URL de Google Maps
                      const urlMaps = `https://www.google.com/maps/search/?api=1&query=${encodedDireccion}`;
                      window.open(urlMaps, "_blank");
                    }}
                  />
                </Grid>
              </Grid>
            ) : null}

            {visibleDatos && servicioTelefono ? (
              <Fragment>
                <h2 style={{ textAlign: "center" }}>Datos del Paciente</h2>
                <Grid container spacing={0} style={{ padding: "0" }}>
                  <Grid
                    item
                    xs={11}
                    md={11}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={servicioTelefono ? servicioTelefono.nombre : null}
                      id="nombre"
                      label="Apellido y Nombre"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={11}
                    md={11}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={
                        servicioTelefono ? servicioTelefono.domicilio : null
                      }
                      id="domicilio"
                      label="Domicilio"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    md={2}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={servicioTelefono ? servicioTelefono.edad : null}
                      id="edad"
                      label="Edad"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    md={3}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={
                        servicioTelefono ? servicioTelefono.telefono : null
                      }
                      id="telefono"
                      label="Teléfono"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    md={3}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={servicioTelefono ? servicioTelefono.celular : null}
                      id="celular"
                      label="Celular"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    md={3}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={
                        servicioTelefono
                          ? servicioTelefono.numeroDocumento
                          : null
                      }
                      id="documento"
                      label="Documento"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={11}
                    md={11}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={
                        servicioTelefono ? servicioTelefono.nombreTitular : null
                      }
                      id="titular"
                      label="Titular"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={5}
                    md={5}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={
                        servicioTelefono && servicioTelefono.antecedenteId
                          ? antecedentes.find(
                              (item) =>
                                item.id === servicioTelefono.antecedenteId
                            ).nombre
                          : null
                      }
                      id="antecedente"
                      label="Antecedente"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={5}
                    md={5}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={
                        servicioTelefono && servicioTelefono.tratamientoId
                          ? tratamientos.find(
                              (item) =>
                                item.id === servicioTelefono.tratamientoId
                            ).nombre
                          : null
                      }
                      id="tratamiento"
                      label="Tratamiento"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={10}
                    md={10}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={
                        servicioTelefono && servicioTelefono.motivoConsultaId
                          ? motivosConsultas.find(
                              (item) =>
                                item.id === servicioTelefono.motivoConsultaId
                            ).nombre
                          : null
                      }
                      id="motivoConsulta"
                      label="Motivo de Consulta"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={10}
                    md={10}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={
                        servicioTelefono ? servicioTelefono.coseguroAbonar : null
                      }
                      id="coseguroAbonar"
                      label="Coseguro a Abonar"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={4}
                    style={{
                      marginLeft: "1vw",
                      marginRight: "1vw",
                      marginTop: "0vw",
                    }}
                  >
                    <h4>Observaciones</h4>
                    <TextareaAutosize
                      id="observaciones"
                      maxRows={5}
                      minRows={5}
                      //value={afiliado.observaciones}
                      aria-label="maximum height"
                      placeholder="Observaciones"
                      defaultValue={
                        notas && notas.length > 0 ? notas[0].nota : null
                      }
                      style={{
                        width: "-webkit-fill-available",
                        marginTop: "0em",
                      }}
                      disabled
                    />
                  </Grid>

                  <Grid
                    item
                    xs={11}
                    md={11}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={trasladoServicio ? trasladoServicio.destino : null}
                      id="traslado"
                      label="Traslado"
                      fullWidth
                      variant="standard"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "black",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} />
                  <Grid item xs={4} md={4} />
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Volver"
                      icon="pi pi-arrow-left"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      className="p-button-danger"
                      onClick={() => {
                        setVisibleDatos(false);
                        setVisibleReceta1(false);
                        setVisibleReceta2(false);
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} md={4} />
                </Grid>
              </Fragment>
            ) : null}

            {visibleReceta1 ? (
              <Fragment>
                <h2 style={{ textAlign: "center" }}>Receta</h2>
                <Grid container spacing={0} style={{ padding: "0" }}>
                  <div className="flex flex-column h-12rem">
                    <div className="flex pt-4 justify-content-end">
                      <Grid container spacing={0} style={{ marginTop: "0vw" }}>
                        <Grid
                          item
                          xs={11}
                          md={5}
                          style={{ marginLeft: "1vw", marginTop: "1vw" }}
                        >
                          <TextField
                            value={
                              servicioTelefono
                                ? servicioTelefono.apellido
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            id="Apellido"
                            label="Apellido"
                            fullWidth
                            variant="standard"
                            onChange={(e) =>
                              guardarServicioTelefono({
                                ...servicioTelefono,
                                apellido: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        <Grid
                          item
                          xs={11}
                          md={5}
                          style={{ marginLeft: "1vw", marginTop: "1vw" }}
                        >
                          <TextField
                            value={
                              servicioTelefono ? servicioTelefono.nombres : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            id="Nombre"
                            label="Nombre"
                            fullWidth
                            variant="standard"
                            onChange={(e) =>
                              guardarServicioTelefono({
                                ...servicioTelefono,
                                nombres: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        <Grid
                          item
                          xs={3}
                          md={2}
                          style={{ marginLeft: "1vw", marginTop: "1vw" }}
                        >
                          <TextField
                            value={
                              servicioTelefono
                                ? servicioTelefono.numeroDocumento
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            id="numeroDocumento"
                            label="D.N.I."
                            fullWidth
                            variant="standard"
                            onChange={(e) =>
                              guardarServicioTelefono({
                                ...servicioTelefono,
                                numeroDocumento: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        <Grid
                          item
                          xs={5}
                          md={2}
                          style={{ marginLeft: "1vw", marginTop: "1vw" }}
                        >
                          <TextField
                            id="nacimiento"
                            label="Fecha Nacimiento"
                            type="date"
                            variant="standard"
                            value={
                              servicioTelefono
                                ? servicioTelefono.nacimiento
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            onChange={(e) => {
                              guardarServicioTelefono({
                                ...servicioTelefono,
                                nacimiento: e.target.value,
                              });
                            }}
                          />
                        </Grid>

                        <Grid
                          item
                          xs={2}
                          md={2}
                          style={{ marginLeft: "0vw", marginTop: "2vw" }}
                        >
                          <Dropdown
                            value={
                              servicioTelefono && servicioTelefono.sexo
                                ? sexos[
                                    sexos.findIndex(
                                      (element) =>
                                        element.nombre === servicioTelefono.sexo
                                    )
                                  ]
                                : null
                            }
                            onChange={(e) => {
                              if (e.value) {
                                guardarServicioTelefono({
                                  ...servicioTelefono,
                                  sexo: e.value.nombre,
                                });
                              } else {
                                guardarServicioTelefono({
                                  ...servicioTelefono,
                                  sexo: null,
                                });
                              }
                            }}
                            options={sexos}
                            optionLabel="nombre"
                            showClear
                            placeholder="Seleccione un sexo"
                            className="w-full md:w-14rem"
                            style={{ marginLeft: "1vw", marginTop: ".75vw" }}
                          />
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          md={4}
                          style={{ marginLeft: "1vw", marginTop: "1vw" }}
                        >
                          <label htmlFor="id">Obra Social: </label>

                          <Dropdown
                            value={
                              obrasSocialesMedicas &&
                              servicioTelefono &&
                              servicioTelefono.obraSocial
                                ? obrasSocialesMedicas[
                                    obrasSocialesMedicas.findIndex(
                                      (element) =>
                                        element.name ===
                                        servicioTelefono.obraSocial
                                    )
                                  ]
                                : null
                            }
                            onChange={(e) => {
                              if (e.value) {
                                guardarServicioTelefono({
                                  ...servicioTelefono,
                                  obraSocial: e.value.name,
                                });
                              } else {
                                guardarServicioTelefono({
                                  ...servicioTelefono,
                                  obraSocial: null,
                                });
                              }
                            }}
                            options={obrasSocialesMedicas}
                            optionLabel="name"
                            showClear
                            filter
                            placeholder="Seleccione obra social"
                            className="w-75"
                            style={{ marginLeft: "1vw", marginTop: ".75vw" }}
                          />
                        </Grid>

                        <Grid
                          item
                          xs={6}
                          md={3}
                          style={{ marginLeft: "1vw", marginTop: "1vw" }}
                        >
                          <TextField
                            value={
                              servicioTelefono
                                ? servicioTelefono.nroObraSocial
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            id="numeroObraSocial"
                            label="Nº Obra Social"
                            fullWidth
                            variant="standard"
                            onChange={(e) =>
                              guardarServicioTelefono({
                                ...servicioTelefono,
                                nroObraSocial: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        {/*    
                    <Grid item size={{ xs: 12, md: 8 }}>
                      <TextField
                        value={
                          servicioTelefono
                            ? pacienteSeleccionado.email
                            : null
                        }
                        slotProps={{
                          inputLabel: {
                            shrink: true,
                          },
                        }}
                        id="email"
                        label="Correo Electrónico"
                        fullWidth
                        variant="standard"
                        onChange={(e) => {
                          if (e.target.value) {
                            guardarPacienteSeleccionado({
                              ...pacienteSeleccionado,
                              email: e.target.value,
                              enviarCorreo: true,
                            });
                          } else {
                            guardarPacienteSeleccionado({
                              ...pacienteSeleccionado,
                              email: null,
                              enviarCorreo: false,
                            });
                          }
                        }}
                      />
                    </Grid>
                    */}

                        <Grid
                          item
                          xs={5}
                          md={4}
                          style={{ marginLeft: "1vw", marginTop: "1vw" }}
                        >
                          <TextField
                            value={
                              servicioTelefono ? servicioTelefono.celular : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            id="telefono"
                            label="Celular"
                            fullWidth
                            variant="standard"
                            onChange={(e) => {
                              if (e.target.value) {
                                guardarServicioTelefono({
                                  ...servicioTelefono,
                                  celular: e.target.value,
                                });
                              } else {
                                guardarServicioTelefono({
                                  ...servicioTelefono,
                                  celular: null,
                                });
                              }
                            }}
                          />
                        </Grid>

                        {/*      
                    <Grid
                      item
                      size={{ xs: 5, md: 2 }}
                      sx={{ marginRight: "0.5em" }}
                    >
                      <FormControlLabel
                        value="yes"
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              servicioTelefono
                                ? pacienteSeleccionado.enviarCorreo
                                : null
                            }
                            style={{ marginLeft: "0.5em" }}
                            onChange={(e) =>
                              guardarPacienteSeleccionado({
                                ...pacienteSeleccionado,
                                enviarCorreo: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Enviar Correo"
                        labelPlacement="start"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={2}
                      sx={{ marginRight: "0.5em" }}
                      style={{ marginLeft: "1vw", marginTop: "1vw" }}
                    >
                      <FormControlLabel
                        value="yes"
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              servicioTelefono
                                ? servicioTelefono.enviarWhatsApp
                                : false
                            }
                            style={{ marginLeft: "0.5em" }}
                            onChange={(e) =>
                              guardarServicioTelefono({
                                ...servicioTelefono,
                                enviarWhatsApp: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Enviar WhatsApp"
                        labelPlacement="start"
                      />
                    </Grid>
                    */}

                        <Grid item xs={12} md={12} />
                      </Grid>
                    </div>
                  </div>

                  <Grid item xs={2} md={2} />
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Siguiente"
                      icon="pi pi-arrow-right"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      className="p-button-success"
                      onClick={() => {
                        // Validar
                        if (
                          servicioTelefono &&
                          (!servicioTelefono.apellido ||
                            servicioTelefono.apellido === "")
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar apellido.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          servicioTelefono &&
                          (!servicioTelefono.nombres ||
                            servicioTelefono.nombres === "")
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar nombre.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          servicioTelefono &&
                          (!servicioTelefono.numeroDocumento ||
                            servicioTelefono.numeroDocumento === "")
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar nro de documento.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          servicioTelefono &&
                          (!servicioTelefono.nacimiento ||
                            servicioTelefono.nacimiento === "")
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar fecha de nacimiento.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          servicioTelefono &&
                          (!servicioTelefono.sexo ||
                            servicioTelefono.sexo === "")
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar sexo.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          servicioTelefono &&
                          (!servicioTelefono.obraSocial ||
                            servicioTelefono.obraSocial === "")
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar obra social.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          servicioTelefono &&
                          (!servicioTelefono.nroObraSocial ||
                            servicioTelefono.nroObraSocial === "")
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar nro de obra social.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          servicioTelefono &&
                          (!servicioTelefono.celular ||
                            servicioTelefono.celular === "")
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar nro de celular.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          servicioTelefono &&
                          servicioTelefono.celular &&
                          servicioTelefono.celular.length !== 10
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "El celular debe tener 10 dígitos.",
                            life: 3000,
                          });
                          return;
                        }

                        guardarServicioTelefono({
                          ...servicioTelefono,
                          tratamientoProlongado: false,
                          duplicado: false,
                          respetarMarca: false,
                        });

                        setVisibleReceta1(false);
                        setVisibleReceta2(true);
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Volver"
                      icon="pi pi-arrow-left"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      className="p-button-danger"
                      onClick={() => {
                        setVisibleReceta1(false);
                        setVisibleReceta2(false);
                      }}
                    />
                  </Grid>
                  <Grid item xs={2} md={2} />
                </Grid>
              </Fragment>
            ) : null}

            {visibleReceta2 ? (
              <Fragment>
                <h2 style={{ textAlign: "center" }}>Receta</h2>
                <Grid container spacing={0} style={{ padding: "0" }}>
                  <Grid
                    item
                    xs={6}
                    md={3}
                    style={{ marginLeft: "2vw", marginTop: "1vw" }}
                  >
                    <TextField
                      id="fecha"
                      label="Fecha"
                      type="date"
                      variant="standard"
                      disabled
                      value={
                        servicioTelefono && servicioTelefono.fpasado
                          ? formatDate(servicioTelefono.fpasado)
                          : null
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                      /*
                  onChange={(e) => {
                    guardarServicioTelefono({
                      ...servicioTelefono,
                      fecha: e.target.value,
                    });
                  }}
                  */
                    />
                  </Grid>

                  <Grid
                    item
                    xs={11}
                    md={8}
                    style={{
                      marginLeft: "2vw",
                      marginTop: "1vw",
                      marginBottom: "2vw",
                    }}
                  >
                    <TextField
                      id="diagnostico"
                      label="Diagnóstico"
                      variant="standard"
                      value={
                        servicioTelefono
                          ? servicioTelefono.detalleDiagnostico
                          : null
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      disabled
                      required
                      /*
                  onChange={(e) => {
                    guardarServicioTelefono({
                      ...servicioTelefono,
                      diagnostico: e.target.value,
                    });
                  }}
                  */
                    />
                  </Grid>

                  <Grid
                    item
                    xs={3.8}
                    md={2}
                    style={{ marginLeft: "1vw", marginTop: "1vw" }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Checkbox
                          color="primary"
                          checked={
                            servicioTelefono
                              ? servicioTelefono.tratamientoProlongado
                              : false
                          }
                          style={{ marginLeft: "0.5em" }}
                          onChange={(e) =>
                            guardarServicioTelefono({
                              ...servicioTelefono,
                              tratamientoProlongado: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Tratamiento Prolongado"
                      labelPlacement="start"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3.8}
                    md={2}
                    style={{ marginLeft: "1vw", marginTop: "1vw" }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Checkbox
                          color="primary"
                          checked={
                            servicioTelefono
                              ? servicioTelefono.duplicado
                              : false
                          }
                          style={{ marginLeft: "0.5em" }}
                          onChange={(e) =>
                            guardarServicioTelefono({
                              ...servicioTelefono,
                              duplicado: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Duplicado"
                      labelPlacement="start"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3.8}
                    md={2}
                    style={{ marginLeft: "1vw", marginTop: "1vw" }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Checkbox
                          color="primary"
                          checked={
                            servicioTelefono
                              ? servicioTelefono.respetarMarca
                              : false
                          }
                          style={{ marginLeft: "0.5em" }}
                          onChange={(e) =>
                            guardarServicioTelefono({
                              ...servicioTelefono,
                              respetarMarca: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Respetar Marca"
                      labelPlacement="start"
                    />
                  </Grid>
                  <Grid item xs={12} md={12} />

                  <Grid
                    item
                    xs={12}
                    md={5}
                    style={{
                      marginLeft: "1vw",
                      marginTop: "2vw",
                    }}
                  >
                    <Dropdown
                      value={medicamentoElegido}
                      onChange={(e) => {
                        setMedicamentoElegido(e.value);
                        setPresentacionElegida(null);
                      }}
                      options={medicamentos}
                      optionLabel="detalle"
                      placeholder="Seleccione un medicamento"
                      filter
                      showClear
                      className="w-75"
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={5}
                    style={{
                      marginLeft: "1vw",
                      marginTop: "2vw",
                    }}
                  >
                    <Dropdown
                      value={presentacionElegida}
                      onChange={(e) => {
                        if (e.value) {
                          setPresentacionElegida(e.value);
                        } else {
                          setPresentacionElegida(null);
                        }
                      }}
                      options={
                        presentaciones &&
                        presentaciones.length > 0 &&
                        medicamentoElegido
                          ? presentaciones.filter(
                              (element) => element.id === medicamentoElegido.id
                            )
                          : null
                      }
                      disabled={!medicamentoElegido}
                      optionLabel="presentacion"
                      showClear
                      placeholder="Seleccione una Presentación"
                      className="w-full md:w-14rem"
                    />
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    md={2}
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                  >
                    <TextField
                      value={cantidadMedicamento ? cantidadMedicamento : ""}
                      type="number"
                      required
                      id="cantidad"
                      label="Cantidad"
                      disabled={!presentacionElegida}
                      fullWidth
                      variant="standard"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => {
                        setCantidadMedicamento(e.target.value);
                      }}
                    />
                  </Grid>

                  <div className="flex pt-4 justify-content-between">
                    <Button
                      label="Agregar"
                      severity="success"
                      icon="pi pi-check"
                      className="p-button-rounded p-button-success"
                      style={{
                        marginRight: "1vw",
                        marginTop: "2vw",
                        marginLeft: "1vw",
                        marginBottom: "1vw",
                      }}
                      onClick={() => {
                        if (!medicamentoElegido) {
                          toast.current.show({
                            severity: "info",
                            summary: "Receta",
                            detail: "Debe seleccionar un medicamento.",
                            life: 3000,
                          });
                          return;
                        }
                        if (!presentacionElegida) {
                          toast.current.show({
                            severity: "info",
                            summary: "Receta",
                            detail: "Debe seleccionar una presentacion.",
                            life: 3000,
                          });
                          return;
                        }
                        if (
                          !cantidadMedicamento ||
                          Number(cantidadMedicamento) <= 0
                        ) {
                          toast.current.show({
                            severity: "info",
                            summary: "Receta",
                            detail: "Debe seleccionar una cantidad.",
                            life: 3000,
                          });
                          return;
                        }

                        agregarMedicamento();
                      }}
                    />
                    <Button
                      id="cancelarMedicamento"
                      label="Cancelar"
                      severity="danger"
                      icon="pi pi-times"
                      className="p-button-rounded p-button-help"
                      iconPos="right"
                      style={{
                        marginBottom: "1vw",
                      }}
                      onClick={() => {
                        setMedicamentoElegido(null);
                        setPresentacionElegida(null);
                        setCantidadMedicamento(null);
                        guardarServicioTelefono({
                          ...servicioTelefono,
                          tratamientoProlongado: false,
                          duplicado: false,
                          respetarMarca: false,
                        });
                      }}
                    />
                  </div>

                  <Grid item xs={12} md={12} />

                  <Grid
                    item
                    xs={11}
                    md={11}
                    style={{ marginLeft: "1vw", marginTop: "5vw" }}
                  >
                    <DataTable
                      value={medicamentosRecetas}
                      size={"small"}
                      tableStyle={{ minWidth: "50rem" }}
                      style={{ marginLeft: "1vw" }}
                      emptyMessage="No hay datos"
                    >
                      <Column field="medicamento" header="Medicamento"></Column>
                      <Column
                        field="presentacion"
                        header="Presentación"
                      ></Column>
                      <Column field="cantidad" header="Cantidad"></Column>
                      <Column
                        field="prolongado"
                        header="T. Prolongado"
                        body={prolongadoTemplate}
                      ></Column>
                      <Column
                        field="duplicado"
                        header="Duplicado"
                        body={duplicadoTemplate}
                      ></Column>
                      <Column
                        field="respetar"
                        header="Respetar Marca"
                        body={respetarTemplate}
                      ></Column>
                      <Column
                        style={{ flex: "0 0 4rem" }}
                        body={itemTemplate}
                      ></Column>
                    </DataTable>
                  </Grid>

                  <Grid item xs={2} md={2} />
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Generar"
                      icon="pi pi-arrow-right"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      className="p-button-success"
                      onClick={() => {
                        if (
                          !servicioTelefono ||
                          servicioTelefono.fpasado === undefined ||
                          servicioTelefono.fpasado === null ||
                          servicioTelefono.fpasado.trim() === ""
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar una fecha.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          servicioTelefono &&
                          (!servicioTelefono.detalleDiagnostico ||
                            servicioTelefono.detalleDiagnostico === "")
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar un diagnóstico.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          !medicamentosRecetas ||
                          medicamentosRecetas.length <= 0
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Receta",
                            detail: "Debe ingresar un medicamento.",
                            life: 3000,
                          });
                          return;
                        }

                        setVisibleDatos(false);
                        setVisibleReceta1(false);
                        setVisibleReceta2(false);
                        aceptarClick();
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Volver"
                      icon="pi pi-arrow-left"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      className="p-button-danger"
                      onClick={() => {
                        setVisibleReceta2(false);
                        setVisibleReceta1(true);
                      }}
                    />
                  </Grid>

                  <Grid item xs={2} md={2} />
                </Grid>
              </Fragment>
            ) : null}

            {visibleIndicaciones ? (
              <Fragment>
                <h2 style={{ textAlign: "center" }}>Indicaciones</h2>
                <Grid container spacing={0} style={{ padding: "0" }}>
                  <Grid
                    item
                    xs={11}
                    md={4}
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                      marginTop: "2vw",
                    }}
                  >
                    <h4>Indicaciones</h4>
                    <TextareaAutosize
                      id="indicaciones"
                      maxRows={5}
                      minRows={5}
                      //value={afiliado.observaciones}
                      aria-label="maximum height"
                      placeholder="Indicaciones"
                      defaultValue={
                        servicioTelefono && servicioTelefono.indicaciones
                          ? servicioTelefono.indicaciones
                          : null
                      }
                      style={{
                        width: "-webkit-fill-available",
                        marginTop: "0em",
                      }}
                      onChange={(e) => {
                        guardarServicioTelefono({
                          ...servicioTelefono,
                          indicaciones: e.target.value,
                        });
                        verificarReposo(e.target.value);
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} />
                  <Grid item xs={2} md={2} />
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Aceptar"
                      icon="pi pi-check"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      className="p-button-success"
                      onClick={() => {
                        if (
                          servicioTelefono &&
                          !servicioTelefono.indicaciones
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Indicaciones",
                            detail: "Debe ingresar las indicaciones.",
                            life: 3000,
                          });
                          return;
                        }

                        localStorage.setItem(
                          "indicaciones",
                          servicioTelefono.indicaciones
                        );
                        generarIndicacionesTelemedicina({
                          servicioTelefono,
                          medico,
                        });
                        setVisibleIndicaciones(false);
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Volver"
                      icon="pi pi-arrow-left"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      className="p-button-danger"
                      onClick={() => {
                        setVisibleReceta1(false);
                        setVisibleReceta2(false);
                        setVisibleIndicaciones(false);
                      }}
                    />
                  </Grid>

                  <Grid item xs={2} md={2} />
                </Grid>
              </Fragment>
            ) : null}

            {visibleDiagnostico ? (
              <Fragment>
                <h2 style={{ textAlign: "center" }}>Diagnóstico</h2>
                <Grid container spacing={0} style={{ padding: "0" }}>
                  <Grid
                    item
                    xs={11}
                    md={5}
                    style={{ marginLeft: "2vw", marginTop: "1vw" }}
                  >
                    <Autocomplete
                      id="diagnostico"
                      fullWidth
                      options={diagnosticos}
                      disablePortal
                      //defaultValue={colores[idColorDefault]}
                      defaultValue={
                        servicioTelefono &&
                        servicioTelefono.diagnosticoId &&
                        servicioTelefono.diagnosticoId !== undefined
                          ? diagnosticos[
                              diagnosticos.findIndex(
                                (item) =>
                                  item.id === servicioTelefono.diagnosticoId
                              )
                            ]
                          : null
                      }
                      getOptionLabel={(option) => option.nombre}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Diagnóstico"
                          variant="standard"
                        />
                      )}
                      //onKeyDown={handleEnter}
                      onChange={(event, value) => {
                        if (value) {
                          let elem = acMotivo.current.getElementsByClassName(
                            "MuiAutocomplete-clearIndicator"
                          )[0];
                          if (elem) {
                            elem.click();
                          }
                          guardarServicioTelefono({
                            ...servicioTelefono,
                            diagnosticoId: value.id,
                          });
                        } else {
                          guardarServicioTelefono({
                            ...servicioTelefono,
                            diagnosticoId: null,
                          });
                          let elem = acMotivo.current.getElementsByClassName(
                            "MuiAutocomplete-clearIndicator"
                          )[0];
                          if (elem) {
                            elem.click();
                          }
                        }
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={11}
                    md={5}
                    style={{ marginLeft: "2vw", marginTop: "1vw" }}
                  >
                    <Autocomplete
                      id="motivoConsulta"
                      ref={acMotivo}
                      fullWidth
                      options={
                        motivosConsultas
                          ? motivosConsultas.filter(
                              (element) =>
                                element.color === "ROJO" ||
                                element.color === "VERDE" ||
                                element.color === "AMARILLO"
                            )
                          : null
                      }
                      disablePortal
                      //defaultValue={colores[idColorDefault]}
                      defaultValue={
                        servicioTelefono &&
                        servicioTelefono.motivoConsultaId &&
                        servicioTelefono.motivoConsultaId !== undefined
                          ? motivosConsultas.findIndex(
                              (item) =>
                                item.id === servicioTelefono.motivoConsultaId
                            ) !== -1
                            ? motivosConsultas[
                                motivosConsultas.findIndex(
                                  (item) =>
                                    item.id ===
                                    servicioTelefono.motivoConsultaId
                                )
                              ]
                            : null
                          : null
                      }
                      getOptionLabel={(option) => option.nombre}
                      renderOption={(props, option) => {
                        const { nombre, codColor } = option;
                        return (
                          <li
                            {...props}
                            style={{
                              backgroundColor: codColor,
                              color:
                                codColor === "#FFFF00" ||
                                codColor === "#FFFFFF" ||
                                codColor === "#00FFFF"
                                  ? "#000000"
                                  : "#FFFFFF",
                            }}
                          >
                            {nombre}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Motivo de Consulta"
                          variant="standard"
                        />
                      )}
                      //onKeyDown={handleEnter}
                      onChange={(event, value) => {
                        if (value) {
                          guardarServicioTelefono({
                            ...servicioTelefono,
                            motivoConsultaId: value.id,
                            color: value.color,
                          });
                        } else {
                          guardarServicioTelefono({
                            ...servicioTelefono,
                            motivoConsultaId: null,
                            color: null,
                          });
                        }
                      }}
                      disabled={
                        (servicioTelefono.diagnosticoId &&
                          diagnosticos.find(
                            (item) => item.id === servicioTelefono.diagnosticoId
                          ).nombre !== motivoEnvio) ||
                        !servicioTelefono.diagnosticoId
                      }
                    />
                  </Grid>

                  <Grid
                    item
                    xs={11}
                    md={11}
                    style={{
                      marginLeft: "2vw",
                      marginRight: "2vw",
                      marginTop: "2vw",
                    }}
                  >
                    <h4>Detalle</h4>
                    <TextareaAutosize
                      id="detalle"
                      maxRows={5}
                      minRows={5}
                      //value={afiliado.observaciones}
                      aria-label="maximum height"
                      placeholder="Detalle"
                      defaultValue={
                        servicioTelefono && servicioTelefono.detalleDiagnostico
                          ? servicioTelefono.detalleDiagnostico
                          : null
                      }
                      style={{
                        width: "-webkit-fill-available",
                        marginTop: "0em",
                      }}
                      onChange={(e) =>
                        guardarServicioTelefono({
                          ...servicioTelefono,
                          detalleDiagnostico: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12} />
                  <Grid item xs={2} md={2} />
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Aceptar"
                      icon="pi pi-check"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      className="p-button-success"
                      onClick={() => {
                        if (
                          servicioTelefono &&
                          !servicioTelefono.diagnosticoId
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Diagnóstico",
                            detail: "Debe ingresar el diagnóstico.",
                            life: 3000,
                          });
                          return;
                        }

                        if (
                          servicioTelefono &&
                          !servicioTelefono.detalleDiagnostico
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Detalle Diagnóstico",
                            detail: "Debe ingresar el detalle del diagnóstico.",
                            life: 3000,
                          });
                          return;
                        }

                        let motivo = diagnosticos.find(
                          (item) => item.id === servicioTelefono.diagnosticoId
                        ).nombre;

                        if (
                          servicioTelefono &&
                          motivo === motivoEnvio &&
                          !servicioTelefono.motivoConsultaId
                        ) {
                          toast.current.show({
                            severity: "warn",
                            summary: "Telemedicina",
                            detail:
                              "Debe cargar un motivo de consulta para este diagnóstico.",
                            life: 3000,
                          });
                          return;
                        }

                        localStorage.setItem(
                          "diagnosticoId",
                          servicioTelefono.diagnosticoId
                        );
                        localStorage.setItem(
                          "detalleDiagnostico",
                          servicioTelefono.detalleDiagnostico
                        );
                        localStorage.setItem(
                          "motivoConsultaId",
                          servicioTelefono.motivoConsultaId
                        );
                        setVisibleReceta1(false);
                        setVisibleReceta2(false);
                        setVisibleDiagnostico(false);
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Volver"
                      icon="pi pi-arrow-left"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      className="p-button-danger"
                      onClick={() => {
                        setVisibleReceta1(false);
                        setVisibleReceta2(false);
                        setVisibleDiagnostico(false);
                      }}
                    />
                  </Grid>
                  <Grid item xs={2} md={2} />
                </Grid>
              </Fragment>
            ) : null}

            {visibleGestion ? (
              <Fragment>
                <h2 style={{ textAlign: "center" }}>Recetas - Indicaciones</h2>
                <Grid container spacing={0} style={{ padding: "0" }}>
                  {/*
              <Grid
                item
                xs={11}
                md={11}
                style={{ marginLeft: "1vw", marginTop: "5vw" }}
              >
                <DataTable
                  value={recetas}
                  size={"small"}
                  tableStyle={{ minWidth: "50rem" }}
                  style={{ marginLeft: "1vw" }}
                  emptyMessage="No hay datos"
                >
                  <Column field="id" header="ID"></Column>
                  <Column field="fecha" header="Fecha"></Column>
                  <Column field="tipo" header="Tipo"></Column>
                </DataTable>
              </Grid>
              */}

                  <div className="card">
                    <DataView
                      value={recetas}
                      itemTemplate={itemTemplateGestion}
                      layout="grid"
                      emptyMessage="No hay datos."
                    />
                  </div>

                  <Grid item xs={12} md={12} />
                  <Grid item xs={12} md={12} />
                  <Grid item xs={2} md={2} />
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Enviar"
                      icon="pi pi-send"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      disabled={recetas && recetas.length === 0}
                      className="p-button-info"
                      onClick={() => {
                        setVisibleDatos(false);
                        setVisibleReceta1(false);
                        setVisibleReceta2(false);
                        setVisibleGestion(false);
                        confirmarEnviar();
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <Button
                      label="Volver"
                      icon="pi pi-arrow-left"
                      style={{
                        marginLeft: "2vw",
                        marginTop: "5vw",
                      }}
                      className="p-button-danger"
                      onClick={() => {
                        setVisibleDatos(false);
                        setVisibleReceta1(false);
                        setVisibleReceta2(false);
                        setVisibleGestion(false);
                      }}
                    />
                  </Grid>

                  <Grid item xs={2} md={2} />
                </Grid>
              </Fragment>
            ) : null}
          </Fragment>
        ) : (
          <Fragment>
            {!telefonoIdStorage ? (
              <Grid item xs={4} md={4}>
                <Button
                  label="Inicializar"
                  icon="pi pi-bars"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-info"
                  onClick={() => {
                    setVisibleInicializar(true);
                  }}
                />
              </Grid>
            ) : null}

            {visibleInicializar && !telefonoIdStorage ? (
              <Grid container spacing={0} style={{ padding: "0" }}>
                <Grid
                  item
                  xs={11}
                  md={3}
                  style={{ marginLeft: "1vw", marginTop: "5vw" }}
                >
                  <TextField
                    id="telefonoId"
                    label="ID de teléfono"
                    fullWidth
                    variant="standard"
                    value={telefonoId ? telefonoId : null}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      obtenerTelefono({ idTelefono: e.target.value });
                      setTelefonoId(e.target.value);
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={11}
                  md={3}
                  style={{ marginLeft: "1vw", marginTop: "2vw" }}
                >
                  <TextField
                    id="telefonoNumero"
                    label="Número de teléfono"
                    fullWidth
                    variant="standard"
                    value={numeroTelefono ? numeroTelefono : null}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => setNumeroTelefono(e.target.value)}
                  />
                </Grid>

                <Grid
                  item
                  xs={11}
                  md={3}
                  style={{ marginLeft: "1vw", marginTop: "2vw" }}
                >
                  <TextField
                    id="telefonoClave"
                    label="Clave de teléfono"
                    fullWidth
                    variant="standard"
                    value={claveTelefono ? claveTelefono : null}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => setClaveTelefono(e.target.value)}
                  />
                </Grid>

                <Grid item xs={2} md={2} />
                <Grid item xs={4} md={4}>
                  <Button
                    label="Aceptar"
                    icon="pi pi-check"
                    style={{
                      marginLeft: "2vw",
                      marginTop: "5vw",
                    }}
                    className="p-button-success"
                    onClick={() => {
                      if (!telefonoId) {
                        toast.current.show({
                          severity: "error",
                          summary: "Inicializar",
                          detail: "Debe ingresar ID de teléfono.",
                          life: 3000,
                        });
                        return;
                      }

                      if (!numeroTelefono) {
                        toast.current.show({
                          severity: "error",
                          summary: "Inicializar",
                          detail: "Debe ingresar número de teléfono.",
                          life: 3000,
                        });
                        return;
                      }

                      if (!claveTelefono) {
                        toast.current.show({
                          severity: "error",
                          summary: "Inicializar",
                          detail: "Debe ingresar clave de teléfono.",
                          life: 3000,
                        });
                        return;
                      }

                      if (
                        Number(telefonoId) !== telefono.id ||
                        numeroTelefono !== telefono.numero ||
                        claveTelefono !== telefono.clave
                      ) {
                        toast.current.show({
                          severity: "error",
                          summary: "Inicializar",
                          detail: "Los datos no coinciden.",
                          life: 3000,
                        });
                        return;
                      }

                      localStorage.setItem("telefonoId", telefonoId);
                      localStorage.setItem("numeroTelefono", numeroTelefono);

                      toast.current.show({
                        severity: "success",
                        summary: "Inicializar",
                        detail: "El teléfono se ha inicializado correctamente.",
                        life: 3000,
                      });

                      setVisibleInicializar(false);
                      setTimeout(() => {
                        window.location.reload();
                      }, 3000);
                    }}
                  />
                </Grid>
                <Grid item xs={4} md={4}>
                  <Button
                    label="Cancelar"
                    icon="pi pi-arrow-left"
                    style={{
                      marginLeft: "2vw",
                      marginTop: "5vw",
                    }}
                    className="p-button-danger"
                    onClick={() => {
                      setTelefonoId(null);
                      setNumeroTelefono(null);
                      setClaveTelefono(null);
                      setVisibleInicializar(false);
                    }}
                  />
                </Grid>

                <Grid item xs={2} md={2} />
              </Grid>
            ) : state.autenticado &&
              servicioTelefono &&
              servicioTelefono.tripulaciones &&
              telefonoIdStorage &&
              Number(telefonoIdStorage) !==
                servicioTelefono.tripulaciones.telefonoId ? (
              <Grid item xs={4} md={4} style={{ marginLeft: "2vw" }}>
                <h3>El servicio corresponse a otro móvil.</h3>
              </Grid>
            ) : null}
          </Fragment>
        )}
      </Fragment>
    </Fragment>
  );
}
